// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_o5_3y","startPage":"style_startPage_2fvDS","bearBg":"style_bearBg_1ay6p"};